/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { flowRight as compose } from 'lodash';
import { Link, SetURLSearchParams } from 'react-router-dom';
import gql from 'graphql-tag';
// import { FaSearch } from 'react-icons/fa';
import Select from 'react-select';

import s from './Professions.module.scss';
import { ROUTE_PREFIX } from '../../constants/router';
import AppContext, { AppContextType } from '../../context';
import { E_TYPE, JOBS_VERSION } from '../../constants/professions';
// import getAssetLink from '../../util/getAssetLink';
import Loading from '../Loading';
import { withSEO } from '../SEO/withSEO';
import { withSearchParams } from '../../util/withSearchParams';

const allProfessionsQuery = gql`
  query allProfessions {
    allProfessions {
      key
      title
      slug
      imageName
      education
    }
  }
`;

const eTypeOptions = Object.keys(E_TYPE).map((key) => ({
  value: key,
  label: E_TYPE[key] === 'ALLE' ? 'Alle Ausbildungswege' : E_TYPE[key],
}));

const extractSearchParams = (searchParams: URLSearchParams): any =>
  ['search', 'education'].reduce((all, key) => {
    if (searchParams.get(key) != null) {
      return { ...all, [key]: searchParams.get(key) };
    }
    return all;
  }, {});

interface ProfessionsProps {
  searchParams: URLSearchParams;
  setSearchParams: SetURLSearchParams;
}

const pageItemSize = 4 * 3 * 2;

class Professions extends React.Component<ProfessionsProps> {
  static contextType = AppContext;

  // eslint-disable-next-line react/state-in-constructor
  state: any;

  loaderRef: any;

  observer: any;

  constructor(props: any) {
    super(props);

    this.state = {
      loading: true,
      // currentSearch: this.props.searchParams.get('search'),
      professions: [],
      shownItems: pageItemSize,
    };

    this.loaderRef = React.createRef();

    this.fetchAllProfessions = this.fetchAllProfessions.bind(this);
    this.renderFilterMenu = this.renderFilterMenu.bind(this);
    this.renderContent = this.renderContent.bind(this);
  }

  componentDidMount(): void {
    this.fetchAllProfessions();
  }

  componentDidUpdate(prevProps: any, prevState: any): void {
    if (!this.state.loading && this.loaderRef?.current != null) {
      if (this.observer) {
        this.observer.disconnect();
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            const nextShownItems = Math.min(
              this.state.shownItems + pageItemSize,
              this.state.professions.length,
            );
            if (nextShownItems !== prevState.shownItems) {
              this.setState({
                shownItems: nextShownItems,
              });
            }
          }
        },
        { threshold: 1.0 },
      );

      this.observer.observe(this.loaderRef.current);
    }
  }

  async fetchAllProfessions() {
    try {
      const result = await (this.context as AppContextType).client.query({
        query: allProfessionsQuery,
        fetchPolicy: 'network-only',
      });

      this.setState({
        loading: false,
        professions: result.data.allProfessions
          .map((p: any) => ({
            ...p,
            imageName: `https://www.jopsy.at/appimages/jobs/${JOBS_VERSION}/${p.imageName}`,
          }))
          .sort((p1: any, p2: any) => (p1.title <= p2.title ? -1 : 1)),
      });
    } catch (e: any) {
      this.setState({ loading: false });
      // do nothing
    }
  }

  // eslint-disable-next-line class-methods-use-this
  renderFilterMenu() {
    const { searchParams, setSearchParams } = this.props;
    // const { currentSearch } = this.state;

    // const search = searchParams.get('search');
    const educationFilter = searchParams.get('education');

    return (
      <div className={s.filterMenu}>
        <h1>BERUFE ENTDECKEN</h1>
        <div className={s.filters}>
          {/* <form
            className={s.searchFieldForm}
            id="add-experience-form"
            onSubmit={async (e) => {
              e.preventDefault();

              let newSearch = (e.target as any).elements.search.value;
              if (newSearch == null || newSearch.trim() === '') {
                newSearch = null;
              }

              const newSearchParams = extractSearchParams(searchParams);

              if (newSearch != null) {
                newSearchParams.search = newSearch;
              } else {
                delete newSearchParams.search;
              }

              setSearchParams(newSearchParams);
              this.setState({ shownItems: pageItemSize });
            }}
          >
            <input
              className={s.searchField}
              id="search"
              type="text"
              name="search"
              placeholder=""
              value={currentSearch || ''}
              onChange={async (e) => {
                let newSearch: string | null = e.target.value;
                if (newSearch == null || newSearch.trim() === '') {
                  newSearch = null;
                }

                let resetShownItems = false;

                if (search != null && newSearch == null) {
                  const newSearchParams = extractSearchParams(searchParams);
                  delete newSearchParams.search;
                  resetShownItems = true;
                  setSearchParams(newSearchParams);
                }

                const stateChanges: any = { currentSearch: newSearch };
                if (resetShownItems) {
                  stateChanges.shownItems = pageItemSize;
                }

                this.setState(stateChanges);
              }}
            />
            <button className={s.searchButton} type="submit">
              <FaSearch />
            </button>
          </form> */}
          <div className={s.educationFilter}>
            {/* <img src={getAssetLink('academyHat.png')} alt="filter" /> */}
            <Select
              className={s.educationFilterSelect}
              value={
                educationFilter != null
                  ? eTypeOptions.find((o) => o.value === educationFilter) ||
                    eTypeOptions[0]
                  : eTypeOptions[0]
              }
              options={eTypeOptions}
              onChange={(option) => {
                if (option == null || option.value === 'E0') {
                  const newSearchParams = extractSearchParams(searchParams);
                  delete newSearchParams.education;
                  setSearchParams(newSearchParams);
                  this.setState({ shownItems: pageItemSize });
                } else {
                  const newSearchParams = extractSearchParams(searchParams);
                  newSearchParams.education = option.value;
                  setSearchParams(newSearchParams);
                  this.setState({ shownItems: pageItemSize });
                }
              }}
              placeholder=""
              isClearable={false}
              isSearchable={false}
            />
          </div>
        </div>
      </div>
    );
  }

  renderContent() {
    const { professions, shownItems } = this.state;
    const { searchParams } = this.props;

    let filteredProfessions = professions;

    const search = searchParams.get('search');
    const educationFilter = searchParams.get('education');

    if (search != null) {
      const searchLowerCase = search.toLowerCase();
      filteredProfessions = filteredProfessions.filter((p: any) =>
        p.title.toLowerCase().includes(searchLowerCase),
      );
    }

    if (educationFilter != null) {
      filteredProfessions = filteredProfessions.filter((p: any) =>
        p.education.includes(E_TYPE[educationFilter]),
      );
    }

    filteredProfessions = filteredProfessions.slice(0, shownItems);

    if (filteredProfessions.length === 0) {
      return (
        <div className={s.noProfessionsFound}>
          Keine passenden Berufe gefunden
        </div>
      );
    }

    return (
      <div className={s.professionsList}>
        {filteredProfessions.map((profession: any) => (
          <Link
            className={s.tileContainer}
            key={profession.key}
            to={`${ROUTE_PREFIX}/beruf/${profession.slug}`}
          >
            <div className={s.professionImage}>
              <img src={profession.imageName} alt={profession.title} />
            </div>
            <div className={s.tileHeader}>
              <h2>{profession.title}</h2>
            </div>
          </Link>
        ))}

        <div
          ref={this.loaderRef}
          style={{
            height: '50px',
            width: '100%',
            marginTop: '-50vh',
            pointerEvents: 'none',
          }}
        />
      </div>
    );
  }

  render() {
    const { loading } = this.state;

    return (
      <>
        <div className={s.professionsPage} data-nosnippet>
          {this.renderFilterMenu()}
          {!loading && this.renderContent()}
        </div>
        {this.state.loading && <Loading />}
      </>
    );
  }
}

export default compose(
  withSEO({
    title: 'Jopsy | Entdecke neue Berufe für dich!',
    description:
      'Schau doch mal in unsere umfassenden Berufsliste und finde den passenden Beruf für dich!',
  }),
  withSearchParams,
)(Professions);
